import React, { Component } from 'react';

class ContentSection extends Component {

	getSlope() {
		switch (this.props.sectionEffect) {
			case 'uphill':
				return (
					<div className='section-effect mt-md-negative-10'>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none">
							<path className={`fill-${this.props.slopeColor}`} d="M0 97v3h100V5z" />
						</svg>
					</div>
				);
			case 'downhill':
				return (
					<div className="section-effect">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none">
							<path className={`fill-${this.props.slopeColor}`} d="M100 97v3H0V5z" />
						</svg>
					</div>
				);
		}

		return null;
	}

	render() {
		return (
			<section style={{ ...this.props.style }} className={`section ${this.props.addedSectionClass ? this.props.addedSectionClass : ''}`}>
				<div className={`landing-container-fluid ${this.props.addedContainerFluidClass ? this.props.addedContainerFluidClass : ''}`}>
					{this.props.title
						? <div className={`landing-section-header ${this.props.titleContainerClass ? this.props.titleContainerClass : ''}`}>
							<h2 style={{ color: this.props.titleColor }} className={`landing-section-title text-align-center`}>{this.props.title}</h2>
						</div> : null}


					{this.props.children}


				</div>
				{this.props.sectionEffect ? this.getSlope() : null}
			</section>
		);
	}
}

export default ContentSection;


// WEBPACK FOOTER //
// ./src/components/landing/ContentSection.js